import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import { getLocationList } from "@/api/location/getLocationList";

export function LocationList() {
  const query = getLocationList.useQuery();

  if (query.isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (query.isError) {
    return (
      <Alert severity="error">
        Failed to load locations: {JSON.stringify(query.error)}
      </Alert>
    );
  }

  const locations = query.data ?? [];

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: "calc(100vh - 160px)" }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Default</TableCell>
            <TableCell>Deprecated</TableCell>
            <TableCell>Parent</TableCell>
            <TableCell align="right">Bins</TableCell>
            <TableCell align="right">References</TableCell>
            <TableCell>City</TableCell>
            <TableCell>Country</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {locations.map((location) => (
            <TableRow key={location.id} hover>
              <TableCell sx={{ fontFamily: "monospace" }}>{location.id}</TableCell>
              <TableCell>{location.name}</TableCell>
              <TableCell>{location.isDefault ? "Yes" : "—"}</TableCell>
              <TableCell>{location.isDeprecated ? "Yes" : "—"}</TableCell>
              <TableCell>{location.parentName ?? "—"}</TableCell>
              <TableCell align="right">{location.bins.length}</TableCell>
              <TableCell align="right">{location.referenceCount}</TableCell>
              <TableCell>{location.address.citySuburb}</TableCell>
              <TableCell>{location.address.country}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
